// @ts-nocheck

import { downloadRequestWithToken, fetchRequest } from './index';
/**
 * Получение отчета
 */
export const fetchReportDrivers = async params => {
  return await fetchRequest.get('/report/driver-work', {
    ...params
  });
};

/**
 * Печать отчета
 */
export const printReportDrivers = async params => {
  const isPrinted = await downloadRequestWithToken('/report/driver-work/print', {
    ...params
  });
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};
export default {
  fetchReportDrivers,
  printReportDrivers
};
